module.exports = __webpack_public_path__ + "assets/img/a.all_icon.9bd4d0a8.svg";